// libs
import { styled } from '@nykaa/ui-components';

//styles
import { MWEB_HEADER_ZINDEX } from 'shared/styles/base';

export const PopUpContainer = styled.div`
  z-index: ${MWEB_HEADER_ZINDEX - 1};
  box-shadow: ${({ theme }) => theme.elevations.shadow100};
  border-radius: ${({ theme }) => theme.spacing.spacing40};
  width: fit-content;
`;

export const Separator = styled.hr`
  width: 100%;
  margin: ${({ theme }) => theme.spacing.spacing0};
  border-top: ${({ theme }) => `${theme.spacing.spacing0} solid ${theme.colors.surface30}`};
`;

export const TopContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing.spacing100};
  // @ts-expect-error - filterSurface is a custom property not in UI components ColorTokens type
  background-color: ${({ theme }) => theme.colors.filterSurface};
  // @ts-expect-error - filterBackdropFilter is a custom property not in UI components ColorTokens type
  backdrop-filter: blur(${({ theme }) => theme.colors.filterBackdropFilter}px);
`;

export const Wrapper = styled.div`
  position: relative;
`;
